import { Box, Typography } from "@mui/material";
import React from "react";
import {
  Legend,
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  Tooltip,
} from "recharts";
import Ellipse from "../../../../assets/icons/Ellipse";
import { HandleSkeletion } from "../../../../utils/constants";
import {
  CustomDiv,
  WholePageEllipse,
  WholePageOpacity,
} from "../../../chat-bot/style";
import {
  CommonGrid2,
  DotColor,
} from "../../../common-components/StyledComponents";
import { CustomizeRadarChart } from "../../style";

function Comparison({
  matchedData,
  loading,
  disabled,

  CustomTooltip,
}) {
  const renderLegend = (props) => {
    const { payload } = props;
    return (
      <CommonGrid2
        justifyContent="center"
        display={"flex"}
        position={"relative"}
        top={"1.5rem"}
      >
        {payload.map((entry, index) => (
          <CommonGrid2
            key={`item-${index}`}
            alignItems={"center"}
            margin={"0 10px"}
            flexDirection={"row"}
            display={"flex"}
          >
            <DotColor
              color={entry.color}
              marginRight={"5px"}
              width={"10px"}
              height={"10px"}
            ></DotColor>
            <Typography fontSize={"13px"} fontWeight={600} color={"#475467"}>
              {entry.value}
            </Typography>
          </CommonGrid2>
        ))}
      </CommonGrid2>
    );
  };

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return `${text.substring(0, maxLength)}...`;
    }
    return text;
  };

  const CustomPolarRadiusAxisTick = (props) => {
    const { x, y, payload } = props;
    return (
      <text
        x={x}
        y={y}
        dy={16}
        textAnchor="middle"
        fill="#666"
        fontSize={"13px"}
        fontWeight="bold"
      >
        {payload.value}
      </text>
    );
  };

  return loading ? (
    <HandleSkeletion height={100} width={"100%"} />
  ) : (
    <Box
      width={"100%"}
      padding={"10px 10px"}
      marginTop={"0.5rem"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      position={"relative"}
      height={"100%"}
    >
      <CommonGrid2
        container
        rowSpacing={5}
        columnSpacing={1}
        size={12}
        height={"100%"}
        justifyContent="center"
      >
        {disabled && (
          <CustomDiv>
            <WholePageEllipse left="48%">
              <Ellipse />
            </WholePageEllipse>
            <WholePageOpacity right="0px"></WholePageOpacity>
          </CustomDiv>
        )}
        <CustomizeRadarChart
          cx="50%"
          cy="50%"
          outerRadius="90%"
          width={500}
          height={300}
          data={matchedData?.spider_graph_results}
        >
          <PolarGrid />

          <PolarAngleAxis
            dataKey="name"
            tick={({ payload, x, y, textAnchor }) => {
              const truncatedText = truncateText(payload.value, 15);
              return (
                <text
                  x={x}
                  y={y + 4}
                  textAnchor={textAnchor}
                  fontSize="13px"
                  fontWeight="600"
                  title={"payload.value"}
                  fill="#475467"
                >
                  {truncatedText}
                </text>
              );
            }}
          />
          <PolarRadiusAxis
            angle={30}
            domain={[0, 100]}
            tick={CustomPolarRadiusAxisTick}
            axisLine={false}
          />
          <Radar
            name="Candidate Score"
            dataKey="candidate_score"
            stroke="#6941C6"
            fill="#6941C6"
            fillOpacity={0.3}
            strokeWidth={2}
          />
          <Radar
            name="Highest Score"
            dataKey="highest_score"
            stroke="#667085a1"
            fill="#667085a1"
            fillOpacity={0.3}
            strokeWidth={2}
          />
          <Radar
            name="Average Score"
            dataKey="average_score"
            stroke="#F79009"
            fill="#F79009"
            fillOpacity={0.3}
            strokeWidth={2}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend content={renderLegend} />
        </CustomizeRadarChart>
      </CommonGrid2>
    </Box>
  );
}

export default Comparison;
